import { render, staticRenderFns } from "./TabCover.vue?vue&type=template&id=6daefbf1&scoped=true&"
import script from "./TabCover.vue?vue&type=script&lang=js&"
export * from "./TabCover.vue?vue&type=script&lang=js&"
import style0 from "./TabCover.vue?vue&type=style&index=0&id=6daefbf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daefbf1",
  null
  
)

export default component.exports